/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  /**
   * Fulfillment order summary.
   *
   * Reads the per-line fulfillment snapshot properties captured at add-to-cart
   * (_fulfillment_type, _line_ship_date) and writes a cart-level summary to
   * cart attributes for Klaviyo / order routing:
   *   - calculated_last_shipment_date (YYYY-MM-DD, latest of all lines)
   *   - order_fulfillment_mix (rts_only | preorder_only | batch_only | mixed)
   * It also toggles the ship-together cart message.
   */
  (function fulfillmentSummary() {
    var ATTR_LAST_DATE = 'calculated_last_shipment_date';
    var ATTR_MIX = 'order_fulfillment_mix';
    var typeToMix = {ready_to_ship: 'rts', preorder: 'preorder', batch: 'batch'};
    var running = false;
    var lastWritten = {};

    function getRoot() {
      return (window.theme && window.theme.routes && window.theme.routes.root) || '/';
    }

    function computeSummary(cart) {
      var types = {};
      var lastDate = '';

      (cart.items || []).forEach(function (item) {
        var props = item.properties || {};
        var type = props._fulfillment_type || 'ready_to_ship';
        types[type] = true;

        // Consider both the generic line ship date and the batch shipment date
        // so batch products are always included in the latest-date calculation.
        [props._line_ship_date, props._batch_ship_date].forEach(function (shipDate) {
          if (shipDate && shipDate > lastDate) {
            lastDate = shipDate;
          }
        });
      });

      var uniqueTypes = Object.keys(types);
      var mix = '';
      if (uniqueTypes.length === 1) {
        mix = (typeToMix[uniqueTypes[0]] || 'rts') + '_only';
      } else if (uniqueTypes.length > 1) {
        mix = 'mixed';
      }

      return {lastDate: lastDate, mix: mix};
    }

    function toggleMessage(mix, itemCount) {
      var nodes = document.querySelectorAll('[data-fulfillment-cart-message]');
      var show = itemCount > 0 && mix && mix !== 'rts_only';
      nodes.forEach(function (node) {
        node.hidden = !show;
      });
    }

    function syncCartAttributes() {
      if (running) return;
      running = true;

      fetch(getRoot() + 'cart.js', {headers: {Accept: 'application/json'}})
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var summary = computeSummary(cart);
          toggleMessage(summary.mix, cart.item_count);

          var attrs = cart.attributes || {};
          var nextDate = summary.lastDate || '';
          var nextMix = summary.mix || '';

          var needsUpdate =
            (attrs[ATTR_LAST_DATE] || '') !== nextDate ||
            (attrs[ATTR_MIX] || '') !== nextMix;

          var alreadyWritten =
            lastWritten[ATTR_LAST_DATE] === nextDate &&
            lastWritten[ATTR_MIX] === nextMix;

          if (!needsUpdate || alreadyWritten) {
            running = false;
            return;
          }

          var body = {attributes: {}};
          body.attributes[ATTR_LAST_DATE] = nextDate;
          body.attributes[ATTR_MIX] = nextMix;
          lastWritten[ATTR_LAST_DATE] = nextDate;
          lastWritten[ATTR_MIX] = nextMix;

          return fetch(getRoot() + 'cart/update.js', {
            method: 'POST',
            headers: {'Content-Type': 'application/json', Accept: 'application/json'},
            body: JSON.stringify(body),
          }).then(function () {
            running = false;
          });
        })
        .catch(function (err) {
          running = false;
          console.warn('Fulfillment summary sync failed:', err);
        });
    }

    var debounceTimer = null;
    function scheduleSync() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(syncCartAttributes, 250);
    }

    ['theme:cart:added', 'theme:cart:refresh', 'theme:cart:loaded', 'theme:cart:update'].forEach(function (evt) {
      document.addEventListener(evt, scheduleSync);
    });
    if (typeof window.subscribe === 'function' && window.theme && window.theme.PUB_SUB_EVENTS) {
      window.subscribe(window.theme.PUB_SUB_EVENTS.cartUpdate, scheduleSync);
    }
    document.addEventListener('DOMContentLoaded', scheduleSync);
    scheduleSync();
  })();







  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
